// extracted by mini-css-extract-plugin
module.exports = {"base":"Item_base__2Cl5F"};